import { render, staticRenderFns } from "./AccountWithdrawalApplyFkManage.vue?vue&type=template&id=38f9dbce&scoped=true"
import script from "./AccountWithdrawalApplyFkManage.vue?vue&type=script&lang=js"
export * from "./AccountWithdrawalApplyFkManage.vue?vue&type=script&lang=js"
import style0 from "./AccountWithdrawalApplyFkManage.vue?vue&type=style&index=0&id=38f9dbce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f9dbce",
  null
  
)

export default component.exports